module.exports = __webpack_public_path__ + "static/media/cryptomines-logo.cdd760a1.png";